var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrowser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.896,
    height: 16.749,
    viewBox: "0 0 19.896 16.749",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -40.484)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.46,40.484H1.436A1.436,1.436,0,0,0,0,41.92v2.623H19.9V41.92A1.436,1.436,0,0,0,18.46,40.484ZM2.49,43.132a.623.623,0,1,1,.623-.623A.624.624,0,0,1,2.49,43.132Zm2.535,0a.623.623,0,1,1,.623-.623A.624.624,0,0,1,5.025,43.132Zm2.65,0a.623.623,0,1,1,.623-.623A.624.624,0,0,1,7.675,43.132Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,176.808v10.016a1.436,1.436,0,0,0,1.436,1.436H18.46a1.436,1.436,0,0,0,1.436-1.436V176.808Zm6.557,4.624-.811,2.359a.619.619,0,0,1-.575.418H5.161a.619.619,0,0,1-.578-.4l-.293-.766-.256.745a.619.619,0,0,1-.575.418H3.447a.619.619,0,0,1-.578-.4l-.9-2.359a.619.619,0,0,1,1.157-.443l.293.766.256-.745a.622.622,0,0,1,1.164-.02l.293.766.256-.745a.619.619,0,0,1,1.172.4Zm5.69,0-.811,2.359a.619.619,0,0,1-.575.418H10.85a.619.619,0,0,1-.578-.4l-.293-.766-.256.745a.619.619,0,0,1-.575.418H9.137a.619.619,0,0,1-.578-.4l-.9-2.359a.619.619,0,0,1,1.157-.443l.293.766.256-.745a.626.626,0,0,1,1.164-.02l.293.766.256-.745a.619.619,0,0,1,1.172.4Zm5.69,0-.811,2.359a.619.619,0,0,1-.575.418H16.54a.619.619,0,0,1-.578-.4l-.293-.766-.256.745a.619.619,0,0,1-.575.418h-.011a.619.619,0,0,1-.578-.4l-.9-2.359a.619.619,0,0,1,1.157-.443l.293.766.256-.745a.621.621,0,0,1,1.164-.02l.293.766.256-.745a.619.619,0,1,1,1.172.4Z",
    transform: "translate(0 -131.027)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowser);
export default __webpack_public_path__ + "static/media/browser.8a6f91ab0c476f2b41576f310bae386d.svg";
export { ForwardRef as ReactComponent };